export const recyclingContent = {
  hero: {
    title: 'IT Recycling',
    accent: 'E-Waste Solutions',
    subtitle:
      'Secure, responsible recycling for phones, tablets, laptops and business IT equipment across London.',
  },
  trustBadges: [
    { icon: '🔐', label: 'Data Destruction' },
    { icon: '🌱', label: 'Eco Responsible' },
    { icon: '📋', label: 'WEEE Compliant' },
    { icon: '📜', label: 'Destruction Certificate' },
  ],
  intro: {
    title: 'Sustainable IT Recycling',
    accent: 'You Can Trust',
    text: 'SecureFix helps homes and businesses dispose of old electronics the right way. We protect your data and recycle what can be reused.',
  },
  stats: [
    { value: '100%', label: 'Data Security' },
  ],
  process: [
    {
      step: '01',
      icon: '📦',
      title: 'Collection',
      description: 'Book a collection or drop off your devices at SecureFix in London.',
    },
    {
      step: '02',
      icon: '🔍',
      title: 'Assessment',
      description: 'We sort equipment for reuse, parts recovery, or responsible recycling.',
    },
    {
      step: '03',
      icon: '🗑️',
      title: 'Data Destruction',
      description: 'Storage is securely wiped or destroyed so your data cannot be recovered.',
    },
    {
      step: '04',
      icon: '♻️',
      title: 'Recycling',
      description: 'Materials are processed through approved channels with minimal waste.',
    },
    {
      step: '05',
      icon: '✅',
      title: 'Certification',
      description: 'Receive documentation confirming secure destruction and recycling.',
    },
  ],
  categories: [
    {
      icon: '💻',
      title: 'Laptops & Desktops',
      items: ['Windows & Mac computers', 'All-in-ones', 'Workstations'],
    },
    {
      icon: '🖥️',
      title: 'Monitors & Screens',
      items: ['LCD & LED screens', 'Broken displays', 'TV panels'],
    },
    {
      icon: '📡',
      title: 'Servers & Networking',
      items: ['Servers', 'Routers & switches', 'NAS devices'],
    },
    {
      icon: '📱',
      title: 'Mobile Devices & Tablets',
      items: ['Phones', 'Tablets', 'Smart watches'],
    },
    {
      icon: '🎧',
      title: 'IT Accessories',
      items: ['Keyboards & mice', 'Cables & docks', 'Chargers'],
    },
    {
      icon: '🖨️',
      title: 'Printers & Peripherals',
      items: ['Printers & scanners', 'Webcams', 'External drives'],
    },
    {
      icon: '🧩',
      title: 'Components & Parts',
      items: ['Hard drives & SSDs', 'RAM & boards', 'Power supplies'],
    },
  ],
  reasons: [
    {
      icon: '🇬🇧',
      title: 'London Coverage',
      description: 'Collection and drop-off options across Greater London.',
    },
    {
      icon: '🔒',
      title: 'Data Security First',
      description: 'Professional wiping and destruction for business and personal devices.',
    },
    {
      icon: '📄',
      title: 'Transparent Reporting',
      description: 'Clear paperwork so you know what was recycled and destroyed.',
    },
    {
      icon: '⚡',
      title: 'Fast Turnaround',
      description: 'Straightforward booking with same-day help when available.',
    },
    {
      icon: '🏢',
      title: 'Business Friendly',
      description: 'Ideal for office clear-outs, upgrades, and IT refreshes.',
    },
    {
      icon: '🌍',
      title: 'Eco Focused',
      description: 'We prioritise reuse and responsible material recovery.',
    },
  ],
  sectors: [
    { icon: '🏪', label: 'SMEs' },
    { icon: '🎓', label: 'Education' },
    { icon: '🏥', label: 'Healthcare' },
    { icon: '⚖️', label: 'Legal Firms' },
    { icon: '🛒', label: 'Retail' },
    { icon: '🏬', label: 'Corporate Offices' },
    { icon: '🖥️', label: 'IT Providers' },
    { icon: '🏛️', label: 'Public Sector' },
  ],
  faqs: [
    {
      question: 'How do you keep my data secure?',
      answer:
        'We securely wipe or physically destroy storage media before recycling. Ask us for a certificate of destruction for business jobs.',
    },
    {
      question: 'Are you WEEE compliant?',
      answer:
        'Yes. We handle electrical and electronic waste through responsible, compliant recycling channels.',
    },
    {
      question: 'Do you collect from my office or home?',
      answer:
        'Yes. London collection can be arranged for suitable volumes. Smaller quantities can also be dropped off with us.',
    },
    {
      question: 'What devices do you accept?',
      answer:
        'Phones, tablets, laptops, desktops, monitors, networking gear, printers, accessories and many IT components.',
    },
    {
      question: 'Is there a cost to recycle?',
      answer:
        'It depends on volume and device type. Request a quote and we will confirm options for free or chargeable collections.',
    },
    {
      question: 'Can I get documentation for compliance?',
      answer:
        'Yes. We can provide recycling and destruction paperwork suitable for business records and audits.',
    },
  ],
}
